import { Button } from "@omni/ui/components/Button/button.component";
import { parseFloatSafe } from "@omni/utils/number.utils";
import { cn } from "@omni/utils/styles";

import CalculationField, {
    CalculationFieldProps
} from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    id: string;
    index: number;
    updateValues: (index: number, area: { h?: string; w?: string }) => void;
    name?: string;
    isLength?: boolean;
    values: { h?: string; w?: string };
    onRemove?: (index: number) => void;
};

const AreaField = ({
    id,
    index,
    updateValues,
    name,
    isLength,
    values,
    onRemove
}: Props) => {
    const { t } = useGranite();

    const calculationPropsX: CalculationFieldProps = {
        name: "width",
        dimension: "width",
        unit: "m",
        setCalculationValue: (_, value) =>
            updateValues(index, { ...values, w: value }),
        sm: 4,
        md: 4
    };

    const calculationPropsY: CalculationFieldProps = {
        name: isLength ? "length" : "height",
        dimension: isLength ? "length" : "height",
        unit: "m",
        setCalculationValue: (_, value) =>
            updateValues(index, { ...values, h: value }),
        sm: 4,
        md: 4
    };

    return (
        <Row id={id}>
            {name && (
                <Col xs={12}>
                    <h4 className={cn("tw:mb-0")}>
                        <span>
                            {name} {index + 1}
                        </span>
                        {index > 0 && onRemove && (
                            <Button
                                color="link"
                                type="button"
                                className={cn("tw:font-normal")}
                                onClick={() => onRemove(index)}
                            >
                                <i className={cn("las la-trash-alt")} />
                                <span className={cn("tw:ml-2")}>
                                    {t("calculator.wallpaperCalculator.remove")}
                                </span>
                            </Button>
                        )}
                    </h4>
                </Col>
            )}
            <CalculationField
                {...calculationPropsY}
                value={values.h}
                classNames={cn("tw:mt-0")}
            />
            <CalculationField
                {...calculationPropsX}
                value={values.w}
                classNames={cn("tw:mt-0")}
            />
            <Col
                sm={3}
                md={3}
                className={cn(
                    "tw:flex tw:flex-col tw:justify-end tw:text-end tw:max-sm:hidden"
                )}
            >
                <span className={cn("tw:my-2")}>
                    {(parseFloatSafe(values.h, 0) * parseFloatSafe(values.w, 0))
                        .toFixed(2)
                        .toString()
                        .replace(".", ",")}{" "}
                    m<sup>2</sup>
                </span>
            </Col>
        </Row>
    );
};

export default AreaField;
